





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'MessageBox'
})
export default class MessageBox extends Vue {
    @Prop({ required: true })
    public visible!: boolean;

    @Prop({ required: true })
    public title!: string;

    @Prop({ required: true })
    public text!: string;

    @Prop({ required: true })
    public icon!: string;

    get show(): boolean {
        return this.visible;
    }
    set show(visible: boolean) {
        if (!visible) {
            this.$emit('close');
        }
    }

    public confirm(): void {
        this.$emit('confirmed');
        this.show = false;
    }

}
